import { useEffect, Component } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import MarqueeBand from "@/components/Marquee";
import HowItWorks from "@/components/HowItWorks";
import Features from "@/components/Features";
import Developers from "@/components/Developers";
import CtaFooter from "@/components/CtaFooter";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (this.state.failed) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ivory font-sans text-ink">
          Something went wrong. Please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-ivory font-sans text-ink antialiased">
      <ErrorBoundary>
        <Nav />
        <main>
          <Hero />
          <MarqueeBand />
          <HowItWorks />
          <Features />
          <Developers />
          <CtaFooter />
        </main>
      </ErrorBoundary>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            fontFamily: "Manrope, sans-serif",
            borderRadius: "8px",
            border: "1px solid rgba(17,17,17,0.1)",
          },
        }}
      />
    </div>
  );
}
